import { PublicUserModel, UserModel } from '../models';

export const getFriendlyName = (user: UserModel | undefined): string | undefined => {
   if (!user) return undefined;

   return user?.username || user?.fullname?.split(' ')[0] || user?.publicKey?.substring(0, 5) || '';
};

export const getFriendlyPublicName = (user: PublicUserModel): string | undefined => {
   return user.username || user.fullname || user.publicKey?.substring(0, 5) || 'Unknown';
};

export const getFriendlyPublicKey = (user: UserModel | undefined, short: boolean = false): string | undefined => {
   if (!user?.publicKey) return undefined;
   if (short) return user.publicKey.substring(0, 5);
   return user.publicKey.substring(0, 4) + '...' + user.publicKey.substring(user.publicKey.length - 4);
};
